import { tv } from 'tailwind-variants';

export { default as Tooltip } from './Tooltip.vue';
export { default as TooltipProvider } from './TooltipProvider.vue';

export const tooltipVariants = tv({
    slots: {
        content: [
            'pointer-events-none z-tooltip rounded-md border border-gray-200 bg-white px-2 py-1 text-xs font-medium text-gray-900 shadow-sm',
            'data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95',
            'data-[state=instant-open]:animate-in data-[state=instant-open]:fade-in-0 data-[state=instant-open]:zoom-in-95',
            'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
        ],
    },
});
